import {storeFamily} from './reducers/store-family';
import {ProductionState} from './types';
import {ActionReducerMapBuilder} from '@reduxjs/toolkit';

export const extraReducers = (
  builder: ActionReducerMapBuilder<ProductionState>
) => {
  builder.addMatcher(storeFamily.matcher, storeFamily.reducer);
};
